<div class="tab-list nav-section">
	<div class="nav justify-content-center">
		<slot></slot>
	</div>
</div>

<style>
	.nav-section {
		height: 56px;
		box-shadow: 0 1px 0 0 rgba(11, 39, 66, 0.1);
		background: #ffffff;
	}
</style>